/**
 * @fileoverview POST handler for the "/apps/multi_language_settings/download_translation_template" endpoint
 */
import fetch from "@lib/fetch";

import {
  reactQueryMutationAdapter,
  createMutationFetcherFunctionWithShadowError,
} from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsDownloadTranslationTemplateCacheKeys } from "./constants";
import type {
  PostAppsMultiLanguageSettingsDownloadTranslationTemplateProps,
  AppsMultiLanguageSettingsDownloadTranslationTemplateResult,
  DownloadTranslationTemplateErrors,
} from "./types";

export const postAppsMultiLanguageSettingsDownloadTranslationTemplate = reactQueryMutationAdapter(
  appsMultiLanguageSettingsDownloadTranslationTemplateCacheKeys,
  createMutationFetcherFunctionWithShadowError<DownloadTranslationTemplateErrors>()(
    (
      props: PostAppsMultiLanguageSettingsDownloadTranslationTemplateProps
    ): Promise<AppsMultiLanguageSettingsDownloadTranslationTemplateResult> => {
      return fetch(
        "/apps/multi_language_settings/download_translation_template",
        "POST",
        {
          locale_ids: props.localeIds,
          translation_ids: props.translationIds,
          translation_title: props.translationTitle,
          message: props.message,
        },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
